import { create } from 'zustand';

export enum ModalType {
  NONE = 'NONE',
  MENU = 'MENU',
  LANGUAGES = 'LANGUAGES',
  CATEGORIES = 'CATEGORIES',
  SOURCES = 'SOURCES',
  AI_ASSISTANT = 'AI_ASSISTANT',
  MANAGE_COLLECTIONS = 'MANAGE_COLLECTIONS',
  SHARE_ARTICLE = 'SHARE_ARTICLE',
  AUDIO_LIST = 'AUDIO_LIST',
  CONFIRM = 'CONFIRM',
}

interface ModalState {
  modalShown: ModalType;
  modalAdditionalProps?: any; // optional prop
  setModalShown: (modalShown: ModalType, modalAdditionalProps?: any) => void;
  clearModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  modalShown: ModalType.NONE,
  articleId: undefined,
  collectionId: undefined,
  setModalShown: (modal, modalAdditionalProps) =>
    set({ modalShown: modal, modalAdditionalProps }),
  clearModal: () =>
    set({ modalShown: ModalType.NONE, modalAdditionalProps: undefined }),
}));
